export default __webpack_public_path__ + "static/media/bg.dbeded44.png";